import {request} from "../base/HTTP";
import HttpMethod from "../constants/HttpMethod";

export async function getHistories(id) {
    return await request('api/application-history/' + id, {}, HttpMethod.GET);
}
